import { PaymentService } from '@app/_services/payment.service';
import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { CommonUtility } from '@app/_modules/commonUtility';
import { HttpEventType } from '@angular/common/http';
import { saveAs } from 'file-saver';
@Component({
  selector: 'app-capture-response',
  templateUrl: './capture-response.component.html',
  styleUrls: ['./capture-response.component.less']
})
export class CaptureResponseComponent implements OnInit {
receiptData:any;
failedPayment:boolean;
commonUtility:CommonUtility;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private paymentService:PaymentService
    )
    {
      this.failedPayment =false;
      this.commonUtility = paymentService.commonUtility;
      this.route.queryParams.subscribe(params => {

        if(params.payment_status === 'FAILED')
          {this.failedPayment = true;}
          this.receiptData = params;

    });
   }
   redirectHome()
   {
     this.router.navigate(['/']);
   }
   downloadSanskritAcademyTxnReceipt()
   {
    var req={
       "transactionId":this.receiptData.transaction_id,
       "source":this.receiptData.source,
       "id": this.receiptData.id,
    }

     this.paymentService.downloadSanskritAcademyTxnReceipt(req).subscribe((res:any)=>{

      let fileName = 'Transaction-receipt-'+this.receiptData.transaction_id;
      const fileContent = res.body;
      const blob = new Blob([fileContent], { type: 'application/pdf' });
      saveAs(blob, fileName);

    });
    }
  ngOnInit(): void {

  }

}
